

import React, { Component } from 'react';

import './IngestionCharts.css';

import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { format_bytes, get_data_file_url, MISSION_COLOR_PALETTE } from '../../../../utils/data';
import Loading from '@acri-tools/react-tools/components/Loading/Loading';

import SunburstChart from '../../../../components/SunburstChart/SunburstChart';
import Select from '@acri-tools/react-tools/components/Select/Select';
import TreemapChart from '../../../../components/TreemapChart/TreemapChart';
import MediaModal from '../../../../components/MediaModal/MediaModal';

import chartsGuide from '../../../../utils/charts/charts_guide.json';


interface Props {
}
interface State {
    loading: boolean
    data_number?: any
    data_size?: any

    chart_type: string

    chart_width?: number
}

export default class IngestionCharts extends Component<Props, State>{

    ref:any

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            // chart_type: 'treemap'
            chart_type: 'sunburst'
        }

        this.ref= React.createRef();
    }

    componentDidMount() {
        // this.handle_resize();
        window.addEventListener('resize', this.handle_resize);
        this.fetch_data();
        setTimeout(this.handle_resize, 4000)
    }
    componentWillUnmount(){
        window.removeEventListener('resize', this.handle_resize);
    }

    format_data = (data:any, index:number) =>{
        data.name = data.label;
        data.color_index = index;
        // if(!data.value && data.children) data.value = data.children.map((c:any)=> c.value).reduce((sum:number, c:any)=> c + sum );
        // console.debug(`TOTAL ${data.name}`, data.value)
        if(data.children){
            // console.debug(`SUM ${data.name}`, data.children.map((c:any)=> c.value).reduce((sum:number, c:any)=> c + sum ));
            data.children.forEach((child:any, idx:number)=>{ this.format_data(child, index + idx + 1); });
            // Value removed if not the limit... a bit dumb but heck
            delete data.value;
        }
        return data;
    }


    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(`hystorical_sunchart.json`), {
                method: 'get'
            });

            // console.debug("data", res.data)
            
            let data_number = this.format_data({ label:"Products number", children: res.data?.n_prod }, 0);
            let data_size = this.format_data({ label:"Products size", children: res.data?.size }, 0);
            // let data_number = this.format_data({ children: res.data?.n_prod});
            
            // console.debug("data_number", data_number);

            this.setState({
                data_number
                , data_size
            });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    handle_resize = () =>{
        this.setState({ chart_width: 
            this.ref?.current?.getBoundingClientRect()?.width ?
                (
                    window.innerWidth > 900 ?
                        this.ref?.current?.getBoundingClientRect()?.width / 2
                    :
                        this.ref?.current?.getBoundingClientRect()?.width
                ) - 10
            : 
            undefined 
        })
    }


    color = (c:any)=>{
        // console.debug("d",c);
        if(this.state.chart_type === 'sunburst'){
            if(c.__dataNode?.parent?.data?.color_index) return MISSION_COLOR_PALETTE[c.__dataNode?.parent.data.color_index];
            else{ return '#55559c'; }
        }
        else{
            if(c?.parent?.data?.color_index) return MISSION_COLOR_PALETTE[c.parent.data.color_index];
            // if(c?.data?.color_index) return MISSION_COLOR_PALETTE[c.data.color_index];
            else{ return '#55559c'; }
        }


        // if(c?.parent?.data?.color_index) return MISSION_COLOR_PALETTE[c?.parent.data.color_index];
        // else{ return '#55559c'; }
    }

    render() {
        return (
            <div className="ingestion-charts" ref={this.ref}>
                <div className="form-field">
                    <label>Chart type</label>
                    <Select
                        value={this.state.chart_type}
                        options={[
                            {
                                label: <><i className="fas fa-chart-pie"/> Sunburst</>,
                                value: "sunburst"
                            },
                            {
                                label: <><i className="fas fa-th"/> Treemap</>,
                                value: "treemap"
                            }
                        ]}
                        onChange={(chart_type:string)=>{ this.setState({ chart_type }) }}
                    />
                </div>
                {
                    this.state.loading ?
                        <div className="centered">
                            <Loading/>
                        </div>
                        :
                        <div className="ingestion-charts-container" >
                            {
                                this.state.data_size ?
                                <div className="ingestion-chart" >
                                    <div className="ingestion-chart-title">
                                        Dataset by product size(**)
                                        <MediaModal chartData={chartsGuide.sunburst_chart} />
                                    </div>
                                    {
                                        this.state.chart_type === 'treemap' ?
                                            <TreemapChart
                                                excludeRoot
                                                data={this.state.data_size}
                                                color={this.color}
                                                format_value={(value:any)=> format_bytes(value, { base: 1000 }) }
                                                
                                                width={this.state.chart_width}
                                                tooltipContent={(d:any)=>{ return d.data.tooltip || '' }}
                                            />
                                        :
                                            <SunburstChart
                                                excludeRoot
                                                data={this.state.data_size}
                                                color={this.color}
                                                
                                                width={this.state.chart_width}
                                                tooltipContent={(c:any)=>{ return c.tooltip || '' }}
                                            />
                                    }
                                    <div className="note">
                                        ** Please note that datasets with smaller than 0.1 GB 
                                        as well as Live Missions products are not displayed.
                                    </div>
                                </div>
                                : <div className="no-data">NO PRODUCT SIZE DATA</div>
                            }
                            {
                                // false &&
                                this.state.data_number ?
                                <div className="ingestion-chart" >
                                    <div className="ingestion-chart-title">
                                        Dataset by product number
                                        <MediaModal chartData={chartsGuide.sunburst_chart} />
                                    </div>
                                    {
                                        this.state.chart_type === 'treemap' ?
                                            <TreemapChart
                                                data={this.state.data_number}
                                                color={this.color}
                                                width={this.state.chart_width}
                                                tooltipContent={(d:any)=>{ return d.data.tooltip || '' }}
                                            />
                                        :
                                            <SunburstChart
                                                excludeRoot
                                                data={this.state.data_number}
                                                color={this.color}
                                                width={this.state.chart_width}
                                                tooltipContent={(c:any)=>{ return c.tooltip || '' }}
                                            />
                                    }
                                </div>
                                : <div className="no-data">NO PRODUCT NUMBER DATA</div>
                            }
                        </div>
                        // this.state.data
                }
            </div>
        );
    }



};
